import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNav from "../../components/navigation/TopNav";
import { useTranslation } from "react-i18next";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import {
  TableShell,
  Table,
  Th,
  Td,
  NumberTd,
} from "../../components/data/Table";

const narrowShellStyle = {
  width: "100%",
  margin: "0 auto",
};

export default function AdminPendingRequests() {
  const { t } = useTranslation();
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/pending-requests`);
      setRequests(res.data);
    } catch (error) {
      console.error("Error fetching pending transfer requests:", error);
      setRequests([]);
    }
  };

  const handleAction = async (treq_id, action) => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    const endpoint =
      action === "approve"
        ? "approve-money-transfer-request"
        : "cancel-money-transfer-request";

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/admin/${endpoint}`, {
        treq_id: treq_id,
      });
      fetchRequests();
    } catch (error) {
      console.error(`${action} failed:`, error);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <StandardScreen
      background="default"
      topNav={<TopNav title={t("admin_pending_requests.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">
            <Card title={t("admin_pending_requests.title")}>
              {requests.length === 0 ? (
                <div>{t("admin_pending_requests.messages.empty")}</div>
              ) : (
                <TableShell maxHeight="65vh">
                  <Table>
                    <thead>
                      <tr>

                        <Th columnIndex={0} sticky>{t("admin_pending_requests.table.treq_id")}</Th>

                        <Th columnIndex={1} sticky>{t("admin_pending_requests.table.from_fullname")}</Th>
                        <Th>{t("admin_pending_requests.table.from_user_id")}</Th>
                        <Th>{t("admin_pending_requests.table.from_wallet_id")}</Th>
                        <Th>{t("admin_pending_requests.table.delta_tickets_from_wallet")}</Th>
                        <Th>{t("admin_pending_requests.table.delta_money_from_wallet")}</Th>

                        <Th>{t("admin_pending_requests.table.to_fullname")}</Th>
                        <Th>{t("admin_pending_requests.table.to_user_id")}</Th>
                        <Th>{t("admin_pending_requests.table.to_wallet_id")}</Th>
                        <Th>{t("admin_pending_requests.table.delta_tickets_to_wallet")}</Th>
                        <Th>{t("admin_pending_requests.table.delta_money_to_wallet")}</Th>

                        <Th>{t("admin_pending_requests.table.created_at")}</Th>
                        <Th>{t("admin_pending_requests.table.status")}</Th>
                        <Th>{t("admin_pending_requests.table.notes")}</Th>

                        <Th>{t("admin_pending_requests.table.approve")}</Th>
                        <Th>{t("admin_pending_requests.table.cancel")}</Th>
                      </tr>
                    </thead>

                    <tbody>
                      {requests.map((r) => (

                        <tr key={r.treq_id}>

                        <Td columnIndex={0} sticky>{r.treq_id}</Td>

                        <Td columnIndex={1} sticky>{r.from_fullname}</Td>
                        <Td>{r.from_user_id}</Td>
                        <Td>{r.from_wallet_id}</Td>
                        <Td>{r.delta_tickets_from_wallet}</Td>
                        <Td>{r.delta_money_from_wallet}</Td>

                        <Td>{r.to_fullname}</Td>
                        <Td>{r.to_user_id}</Td>
                        <Td>{r.to_wallet_id}</Td>
                        <Td>{r.delta_tickets_to_wallet}</Td>
                        <Td>{r.delta_money_to_wallet}</Td>

                          <Td>
                            {new Date(r.created_at)
                              .toLocaleString("en-GB", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false,
                              })
                              .replace(",", "")}
                          </Td>

                          <Td>{t(`admin_pending_requests.table.entries.${r.status}`)}</Td>

                          <Td>{r.notes}</Td>

                          <Td> <button onClick={() => handleAction(r.treq_id, "approve")}>
                              ✅
                            </button>
                          </Td>

                          <Td> <button onClick={() => handleAction(r.treq_id, "cancel")}>
                              ❌
                            </button>
                          </Td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableShell>
              )}
            </Card>
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}